<script setup lang="ts">
withDefaults(
  defineProps<{
    value?: boolean
  }>(),
  {
    value: false,
  },
)
</script>

<template>
  <BaseIcon
    :name="value ? 'infoEmpty' : 'cancel'"
    :color="value ? 'stroke-success' : 'stroke-error'"
    data-testid="base-field-read-mode-icon"
    class="mr-2"
  />
</template>
